import React, { Fragment } from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { compose, withProps } from 'recompose';
import Button from 'components/general/Button/Button';
import SubHeader from 'components/general/SubHeader/SubHeader';
import withPrompt from 'components/hoc/withPrompt';
import { selectors } from './../../../../../../shared/ducks/customer.duck';
import OrganisationCustomerDeleteForm from '../containers/OrganisationCustomerDeleteForm';

const customerData = createSelector(
  selectors.data,
  R.applySpec({
    name: R.prop('name'),
  }),
);

const DeleteBtn = compose(
  connect(customerData),
  withProps(({ name }) => ({
    renderPrompt: () => (
      <Fragment>
        <SubHeader
          title={`Delete customer ${name}`}
        />
        <p>Are you sure you want to delete customer {name}?</p>
        <OrganisationCustomerDeleteForm />
      </Fragment>
    ),
  })),
  withPrompt(),
)(({ openPrompt }) => (
  <Button
    onClick={openPrompt}
    types={['accent']}
  >
    Delete
  </Button>
));

export default DeleteBtn;

